<script setup>
import {ref, onBeforeMount, onBeforeUnmount, onMounted} from "vue";
import axios from "axios";
import store from "@/store/store";

const props = defineProps({
  request_id: "",
  request_status_id: "",
  fitter_id: ""
});
const emit = defineEmits(['refresh-requests']);
const error_message = ref();
let is_fitter = ref();
let abonent = ref();
let is_superuser = ref();

const request_type_termination = "754a15de-c6c9-448a-8487-e94bab389ace"
const request_type_disconnection = "d283461c-09b4-430d-b5bd-eba2033ecc54"

const form_data = ref({
  id: '',
  username: '',
  client_id: '',
  client_name: '',
  client_firstname: '',
  client_lastname: '',
  client_middlename: '',
  client_phone: '',
  client_address: '',
  area: '',
  street: '',
  house: '',
  flat: '',
  request_status_name: '',
  request_type: '',
  request_kind: '',
  manager_user_id: '',
  manager_name: '',
  manager_comment: '',
  fitter_id: '',
  fitter_name: '',
  fitter_comment: '',
  date_created: '',
  date_closed: '',
});

let request_statuses = ref([{ "id": 4, "name": "Принял в работу монтёр" },]);

const fetchRequest = async () => {
  try {
    const res = await axios.get('request_details/', {
      params: {
        request_id: props.request_id,
      }
    });
    if (res.data) {
      const data = res.data;
      Object.assign(form_data.value, {
        id: data.id,
        username: data.username,
        request_status_id: data.request_status_id,
        request_status_name: data.request_status_name,
        client_id: data.client_id,
        client_firstname: data.client_firstname,
        client_lastname: data.client_lastname,
        client_middlename: data.client_middlename,
        client_phone: data.client_phone,
        client_address: data.client_address,
        area: data.area,
        street: data.street,
        house: data.house,
        flat: data.flat,
        request_type: data.request_type,
        request_kind: data.request_kind,
        manager_user_id: data.manager_user_id,
        manager_name: data.manager_name,
        manager_comment: data.manager_comment,
        fitter_id: data.fitter_id,
        fitter_name: data.fitter_name,
        fitter_comment: data.fitter_comment,
        date_created: data.date_created,
        date_closed: data.date_closed,
      });
      if (data.request_type_id !== request_type_termination && data.request_type_id !== request_type_disconnection) {
        request_statuses.value = [
          { "id": 4, "name": "Принял в работу монтёр" },
          { "id": 5, "name": "Отмена, по просьбе абонента" },
          { "id": 12, "name": "Выполнен монтёром" },
          { "id": 14, "name": "Не выполнено, абонента нет дома" }
        ];
      } else{
        request_statuses.value = [
          { "id": 4, "name": "Принял в работу монтёр" },
          { "id": 12, "name": "Выполнен монтёром" },
          { "id": 16, "name": "Не отключено, оплатят"},
          { "id": 17, "name": "Не отключено, нет доступа" }
        ]
      }

    } else {
      console.error('No data found for this request.');
    }
  } catch (err) {
    console.error('Error fetching request:', err);
  }
}

const editRequest = async () => {
  try {
    await axios.patch('request_details/', {
      "request_id": props.request_id,
      "request_status_id": form_data.value.request_status_id,
      "request_fitter_comment": form_data.value.fitter_comment
    });

    emit('refresh-requests');
    closeModal();
  } catch (error) {
    if (error.response) {
      // Server responded with a status code outside 2xx range
      error_message.value = error.response.data.ошибка || "An error occurred";
    } else if (error.request) {
      // Request was made but no response received
      error_message.value = "No response from server";
    } else {
      // Something happened in setting up the request
      error_message.value = error.message;
    }
  }
}
const openModal = async () => {
  await fetchRequest(); // Wait until data is loaded
  const modalElement = document.getElementById('edit_request_fitter_' + props.request_id);
  let modal = bootstrap.Modal.getInstance(modalElement);
  if (!modal) {
    modal = new bootstrap.Modal(modalElement);
  }
  modal.show();
};

const closeModal = () => {
  const modal = bootstrap.Modal.getInstance(document.getElementById('edit_request_fitter_'+props.request_id));
  if (modal) {
    error_message.value = ''
    modal.hide();
    history.replaceState(null, null); // Clean history
  }
};
const fitterAcceptRequest = async () => {
  try {
    await axios.patch('request_details/', {
      "request_id": props.request_id,
      "request_status_id": request_statuses.value[0].id,
      "request_fitter_comment": form_data.value.fitter_comment
    });
    emit('refresh-requests');
  } catch (error) {
    console.error(error);
  }
}

const handlePopState = (event) => {
  if (event.state && event.state.modalOpen) {
    closeModal();
  } else {
    history.replaceState(null, null);
  }
};
window.addEventListener('popstate', handlePopState);
onBeforeMount(() => {
  is_fitter.value = store.getters['profile/is_fitter'];
  abonent.value = store.getters['profile/abonent'];
  is_superuser.value = store.getters['profile/is_superuser'];
});
onBeforeUnmount(()=>{
  // Remove the event listener when the component is destroyed
  window.removeEventListener('popstate', handlePopState);
})
</script>

<template>
  <div>
    <div v-if="is_fitter">
      <div v-if="['1', '3'].includes(props.request_status_id)">
        <button
            class="btn btn-outline-primary rounded-5 d-flex align-items-center justify-content-center"
            @click="fitterAcceptRequest"
        >
          <i class="fas fa-check"></i>
        </button>
      </div>

      <button
          class="btn btn-primary"
          v-else-if="!(['12', '14'].includes(props.request_status_id)) && (abonent === props.fitter_id || is_superuser)"
          role="button"
          @click.prevent="openModal()"
      >
        <i class="fas fa-pen"></i>
      </button>
    </div>

    <div
        class="modal fade"
        :id="'edit_request_fitter_'+props.request_id"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title text-bold">Радактирование заявки</h4>
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <div class="mb-1 mb-lg-4">
              <div class="row g-1 g-lg-3">
                <div class="col-12">
                  <label class="form-label">Адрес</label>
                  <p class="form-control-static">
                    {{ form_data.street }} {{ form_data.house }}, квартира {{ form_data.flat }}
                  </p>
                </div>
              </div>
            </div>

            <div class="mb-1 mb-lg-4">
              <div class="row g-1 g-lg-3">
                <div class="col-12 col-md-6">
                  <label class="form-label">ФИО абонента:</label>
                  <p class="form-control-static">{{ form_data.client_lastname }} {{ form_data.client_firstname }} {{ form_data.client_middlename }}</p>
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label">Телефон:</label>
                  <p class="form-control-static">{{ form_data.client_phone }}</p>
                </div>
              </div>
            </div>

            <div class="mb-1 mb-lg-4">
              <div class="row g-0 g-lg-3">
                <div class="col-12 col-md-6">
                  <label class="form-label">Вид:</label>
                  <select class="form-select" disabled>
                    <option selected>{{ form_data.request_type }}</option>
                  </select>
                </div>
                <div class="col-12 col-md-6">
                  <label class="form-label">Причина:</label>
                  <select class="form-select" disabled>
                    <option selected>{{ form_data.request_kind }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="mb-1 mb-lg-4">
              <div class="mb-0 mb-lg-3">
                <label class="form-label">Комментарий менеджера:</label>
                <textarea class="form-control" v-model="form_data.manager_comment" disabled></textarea>
              </div>
              <div class="mb-0 mb-lg-3">
                <label class="form-label">Комментарий монтёра:</label>
                <textarea class="form-control" v-model="form_data.fitter_comment" required></textarea>
              </div>
            </div>
          </div>

          <div class="modal-footer bg-light py-3 px-4 border-top">
            <div class="container-fluid d-flex justify-content-between align-items-center gap-3">
              <div class="flex-grow-1">
                <p class="me-auto text-bold text-danger"  v-if="error_message !== ''">{{error_message}}</p>
                <select
                    :id="'request_status_select_'+props.request_id"
                    class="form-select form-select-sm shadow-sm"
                    v-model="form_data.request_status_id"
                    required
                >

                  <option
                      v-for="status in request_statuses"
                      :value="status.id"
                      :key="status.id"
                      :disabled="status.name === form_data.request_status_name"
                  >
                    {{ status.name }}
                  </option>
                </select>
              </div>

              <button
                  class="btn btn-primary btn-sm flex-shrink-0 d-flex align-items-center gap-2"
                  @click="editRequest"
                  type="submit"
              >
                <i class="fas fa-save"></i>
                <span>Сохранить</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>